module.exports = __webpack_public_path__ + "img/00051.2b227e80.webp";